/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext, useMemo } from "react";
import { isArrayEmpty, isArray, isObject, isArrayNotEmpty } from "utils/empty-exists";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

/**
 * Checks if the
 * @param {import("@tiptap/react").JSONContent | undefined} content 
 */
function useHasContent (content) {
    return useMemo(
        () => {
            if (!content || !isObject(content)) {
                return false;
            }
            const innerContent = content?.content;
            if (isArray(innerContent) && isArrayNotEmpty(innerContent)) {
                return true;
            }
            const isEmpty = isArrayEmpty(innerContent);
            if (isEmpty) {
                return false;
            }
            const isArr = isArray(innerContent);
            const firstItem = innerContent[0];
            const hasKeys = Object.keys(firstItem).length > 1;
            return isArr && hasKeys;
        },
        [content]
    );
}

const RichTextTipTapComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const component = ctx?.component;
    const hide = ctx?.hide ?? false;
    const richtext = component?.richtext;
    const hasContent = useHasContent(richtext);
    
    return (
        <>
            {!hide &&
                <>
                    {!hasContent &&
                        <EmptyContentMessage
                            hasContent={hasContent}
                            component={component}
                        />
                    }
                    {hasContent &&
                        <RichTextPreview
                            richtext={richtext}
                        />
                    }
                </>
            }
        </>
    );
};

RichTextTipTapComponentDisplay.displayName = "RichTextTipTapComponentDisplay";
export { RichTextTipTapComponentDisplay };
